import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../common/Modal';
import DatePicker from '../../common/DatePicker';
import ScheduleCampaignFooter from './ScheduleCampaignFooter';
import { DEFAULT_TIME } from '../constants';
import { timeOptions } from '../helpers';


const ScheduleCampaign = ({ onDateChange, onTimeChange, scheduleCampaign, close, currentDate, submitting }) => (
  <Modal showHeader={false} close={close}>
    <div className="u-pt- u-bg-white">
      <h2 className="c-heading u-ml">Schedule Your Campaign</h2>
      <div className="u-mt+">
        <fieldset className="u-margin-auto u-max-width-360" disabled={submitting}>
          <div className="o-tableize o-tableize--middle">
            <div className="o-tableize__row">
              <div className="o-tableize__cell u-text-center u-pb-">
                <label className="c-label-new" htmlFor="date">
                  Date
                </label>
              </div>
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
                <DatePicker
                  className="c-input u-1/1"
                  name="date"
                  type="text"
                  startDate={new Date()}
                  onChange={onDateChange}
                  value={currentDate}
                  defaultValue={null}
                />
              </div>
            </div>
            <div className="o-tableize__row">
              <div className="o-tableize__cell u-text-center u-pb-">
                <label className="c-label-new" htmlFor="time">
                  Time
                </label>
              </div>
              <div className="o-tableize__cell o-tableize__cell--fill u-pl u-pb-">
                <select
                  className="c-select"
                  defaultValue={DEFAULT_TIME}
                  onChange={onTimeChange}
                >
                  {timeOptions.map(time => (
                    <option value={time.value} key={time.value}>
                      {time.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </fieldset>
        <hr className="c-separator u-mt" />
        <ScheduleCampaignFooter scheduleCampaign={scheduleCampaign} close={close} submitting={submitting} />
      </div>
    </div>
  </Modal>
);
ScheduleCampaign.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  scheduleCampaign: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  currentDate: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default ScheduleCampaign;
